import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatMiniFabButton} from '@angular/material/button';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatFormField, MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select';
import {LanguageService} from '../language.service';

@Component({
  selector: 'nbd-language-selector',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMiniFabButton,
    MatSelect,
    MatSelectTrigger,
    MatOption,
    MatFormField
  ],
  templateUrl: './language-selector.component.html',
  standalone: true,
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  @Input() mode: "floating" | "dropdown" = "floating";
  @Output() languageChange = new EventEmitter<string>();

  constructor(protected ls: LanguageService) {

  }

}
